module.exports = __webpack_public_path__ + "static/media/distance.60182a22.svg";